import {Input, InputProps} from '@chakra-ui/react';
import React, {memo} from 'react';

interface Props extends InputProps {}

export const UiInput = memo(function UiInput({...rest}: Props) {
  return <Input _focus={{borderColor: 'orange.500'}} {...rest} />;
});
